import type { ReactNode } from "react";

/** Rows in order; each run of locked rows is blurred and covered by one brand-coloured upgrade card (shown once, follows the scroll). */
export function LockedStack<T extends { id: string }>({ items, locked, row, card }: { items: T[]; locked: (t: T) => boolean; row: (t: T) => ReactNode; card: ReactNode }) {
  const runs: { locked: boolean; items: T[] }[] = [];
  for (const it of items) {
    const l = locked(it);
    const last = runs[runs.length - 1];
    if (last && last.locked === l) last.items.push(it);
    else runs.push({ locked: l, items: [it] });
  }
  const firstLocked = runs.findIndex((r) => r.locked);
  return (
    <div className="space-y-2">
      {runs.map((run, i) =>
        run.locked ? (
          <div key={i} className="relative min-h-52">
            <ul aria-hidden="true" inert className="pointer-events-none select-none space-y-2 blur-sm">
              {run.items.map((t) => <li key={t.id}>{row(t)}</li>)}
            </ul>
            {i === firstLocked && (
              <div className="absolute inset-0 flex justify-center p-3">
                <div className="sticky top-28 w-full max-w-sm self-start">{card}</div>
              </div>
            )}
          </div>
        ) : (
          <ul key={i} className="space-y-2">
            {run.items.map((t) => <li key={t.id}>{row(t)}</li>)}
          </ul>
        ),
      )}
    </div>
  );
}
